import { PROVIDER_IDS, type ProviderId } from '@/shared/ui/providers'

/**
 * 연결 왕복을 마치고 돌아온 주소가 나르는 결과.
 *
 * 왕복을 시작한 화면이 둘이라 읽는 자리도 둘이다. 파서를 한 자리에 두어 두 화면이 같은 값을
 * 같게 읽는다. 무엇을 보여 줄지는 각 화면이 정한다.
 *
 * 취소하고 돌아온 것은 결과가 아니다. 사용자가 방금 고른 것이고 그것을 다시 알리면 하지 않기로
 * 한 선택을 되묻는 것이 된다.
 *
 * 모르는 값이 오거나 이름이 빠져 있으면 뭉친 실패로 닫는다. 값이 무엇이든 사용자가 할 일은
 * 한 번 더 누르는 것 하나다.
 */
export type LinkOutcome =
  | { kind: 'added'; provider: ProviderId }
  | { kind: 'already-linked'; provider: ProviderId }
  | { kind: 'failed' }
  | null

export function readLinkOutcome(params: URLSearchParams): LinkOutcome {
  const provider = PROVIDER_IDS.find((id) => id === params.get('provider')) ?? null
  const linked = PROVIDER_IDS.find((id) => id === params.get('linked')) ?? null
  if (linked) return { kind: 'added', provider: linked }

  const reason = params.get('reason')
  if (reason === null) return null
  if (reason === 'declined') return null
  if (reason === 'identity_already_linked' && provider) {
    return { kind: 'already-linked', provider }
  }
  return { kind: 'failed' }
}

/** 왕복 결과를 실어 온 값을 주소에서 지운다. 남겨 두면 새로고침마다 같은 안내가 다시 선다. */
export function withoutLinkOutcome(params: URLSearchParams): URLSearchParams | null {
  if (!params.has('linked') && !params.has('reason') && !params.has('provider')) return null
  const next = new URLSearchParams(params)
  next.delete('linked')
  next.delete('reason')
  next.delete('provider')
  return next
}
